import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { Text, View } from 'react-native';
import MarqueeText from '@/components/MarqueeText';
import { cn } from '@/utils/cn';
const ChallengeRank = ({ value, shouldShowUnderline = true, visibleIcon = true, containerClassName, }) => {
    const isTopThree = value.rank < 4;
    return (_jsxs(View, { className: cn('flex-row items-center px-[20px] py-[14px] gap-[16px]', containerClassName), children: [_jsx(View, { className: "w-[40px] h-[26px] justify-center", children: _jsx(Text, { numberOfLines: 1, className: cn(
                    // absolute + 명시 폭 46: RN 은 absolute 자식에게도 부모 폭을 max-width 로
                    // 물려서, 폭을 안 주면 이모지 advance(글리프 잉크 11pt 보다 넓다) 때문에
                    // '1위🥇' 가 '1위…' 로 잘린다. 46 은 최장 케이스('1위🥇' 실측 35.81pt,
                    // '10위' 약 29pt)를 담으면서 닉네임 시작(dx 76)과 겹치지 않는 값이다.
                    'absolute w-[46px] text-[16px] leading-[26px]', isTopThree
                        ? 'font-pretendard-bold text-brand-50'
                        : 'font-pretendard-medium text-gray-60'), children: `${value.rank}위${visibleIcon && isTopThree ? getMedalEmoji(value.rank) : ''}` }) }), _jsxs(View, { className: "flex-1", children: [value.companyName && (_jsx(Text, { className: "text-[11px] font-pretendard-regular text-gray-80", children: value.companyName })), _jsx(MarqueeText, { className: "text-[16px] leading-[24px] tracking-[-0.32px] font-pretendard-medium text-black", children: value.nickname })] }), _jsx(Text, { className: cn('text-[14px] leading-[22px] tracking-[-0.07px] font-pretendard-regular', isTopThree ? 'text-brand-50' : 'text-gray-v2-50'), children: `${value.contributionCount}개 정복` }), shouldShowUnderline && (_jsx(View, { className: "absolute left-[10px] right-[10px] bottom-0 h-px bg-gray-v2-15" }))] }));
};
export default ChallengeRank;
function getMedalEmoji(rank) {
    switch (rank) {
        case 1:
            return '🥇';
        case 2:
            return '🥈';
        case 3:
            return '🥉';
        default:
            return '';
    }
}
